<script>
import {db} from "@/firebase/init";
import {PerfectScrollbar} from "vue2-perfect-scrollbar";
import swal from "sweetalert2";
export default {
  components: {
    PerfectScrollbar
  },
  data () {
    return {
      userData: [],
      loading: false,
      selectedCollaborator: {}
    }
  },
  props: {
    docID: String
  },
  methods: {
    load (data) {
      console.log('all collabs', data)
      this.userData = data
      $('#ticket-access-modal').modal('show');
      $('.modal-backdrop').removeClass("modal-backdrop");
    },
    async giveTicketAccess() {
      try {
        this.loading = true;
        console.log('this.seleectedCollab', this.selectedCollaborator)
        const ref = await db.collection('hostingAccounts').doc(this.docID).get();
        if(ref.exists) {
          const {accounts} = ref.data();
          if(accounts.length) {
            const ip = accounts[0].primary.serverIP;
            const response = await this.$http.post('host-bill/sync-ticket-access-for-collaborator',{
              grant_type: "token",
              collaboratorEmail: this.selectedCollaborator.email,
              UID: this.docID,
              ip,
              email: this.userData.email,
              clientID: this.userData.customerID
            });
            console.log('response from api', response)
          }
        }
        swal('Success', 'We are assigning ticket access to the collaborator. It might takes time to complete the process', 'success');
      } catch (e) {
        console.log('error', e.toString())
        swal('Error', 'Something went wrong while assigning tickets to the collaborator.', 'error');
      } finally {
        this.loading = false
        $('#ticket-access-modal').modal('hide');
      }
    }
  }
}
</script>

<template>
  <div class="stepModal position-relative">
    <div class="modal fade" id="ticket-access-modal" tabindex="-1" role="dialog" aria-labelledby="ticketAccessModal">
      <div class="modal-dialog modal-lg" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title"> Sync Ticket Access </h5>
          </div>
          <div class="modal-body">
            <div class="row">
              <div class="col-md-12">
                <p>Select collaborator</p>
              </div>
              <div class="col-md-12">
                <select v-model="selectedCollaborator" class="form-control" name="" id="">
                    <option disabled value="">Select</option>
                    <option v-for="(row, index) in userData.collaborators" :value="row" :key="index">{{ row.name ? `${row.name} - ${row.email}` : row.email }}</option>
                </select>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <div class="row">
              <div class="col-md-12">
                <button @click="giveTicketAccess" type="submit" class="btn btn-info btn-md d-inline pull-right">
                    <span v-if="loading">
                      <div class="loader" style="width: 15px;height: 15px; margin: 0.2rem 0 !important;"></div>
                    </span>
                  <span v-else>
                        Give Access
                    </span>
                </button>
                <button  type="submit" class="btn btn-default btn-md d-inline pull-right">
                    Close
                </button>

              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped>
.modal-content{
  height: 400px !important;
}
</style>